import PropTypes from 'prop-types';
import { promoShape } from '../promo/shapes';

export const recipeShape = {
  ...promoShape,
  isRevoked: PropTypes.bool.isRequired,
};
